import React from 'react'
import styled from '@emotion/styled'
import { Box, IconButton, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import ClipboardLogo from '../../assets/icons/circles-design/ClipboardLogo.png'

export default function ClipboardTextHolder(props) {
  const DivWrapper = styled.div({
    fieldset: { borderRadius: 80, borderWidth: 0, color: '#F9F9F9' }
  })

  return (
    <>
      <DivWrapper>
        <Box
          bgcolor='#F9F9F9'
          sx={{
            display: 'flex',
            height: 32,
            width: 200,
            borderRadius: 80,
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Typography style={{ marginLeft: 12 }}>{props.children}</Typography>
          <IconButton
            disableRipple
            onClick={() => navigator.clipboard.writeText(props.children)}
            sx={{ marginRight: '8px' }}
          >
            <img src={ClipboardLogo} alt='clipboardlogo' />
          </IconButton>
        </Box>
      </DivWrapper>
    </>
  )
}

ClipboardTextHolder.propTypes = {
  children: PropTypes.element
}
